module.exports = __webpack_public_path__ + "static/media/bitmap@3x.6f077998.png";